import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useAthleteContext } from '../../context/AthleteContext';
import { ComparisonPage } from '../../pages/comparison/ComparisonPage';
import type { ComparisonPrefill } from '../../pages/comparison/types';

interface MobileComparisonPageProps {
  prefill: ComparisonPrefill | null;
  onPrefillConsumed?: () => void;
}

/** PWA route wrapper — mirrors vo2peaks-web AppLayout comparison props. */
export function MobileComparisonPage({ prefill, onPrefillConsumed }: MobileComparisonPageProps) {
  const auth = useAuth();
  const { isCoach, athletes, selectedAthleteId } = useAthleteContext();

  return (
    <ComparisonPage
      user={auth.user}
      coachUserId={auth.user?.id ?? null}
      defaultAthleteId={selectedAthleteId}
      prefill={prefill}
      onPrefillConsumed={onPrefillConsumed}
      athletes={athletes}
      isCoach={isCoach}
    />
  );
}
